export const USER_DATA_KEY = 'userdata';

export const USER_DATA_LOAD_SUCCESS = 'jora-employer/user-data/LOAD_SUCCESS';
export const USER_DATA_UPDATE_SUCCESS =
  'jora-employer/user-data/USER_DATA_UPDATE_SUCCESS';
